import { render, staticRenderFns } from "./IndicatorsStatement-us.vue?vue&type=template&id=31a158eb"
import script from "./IndicatorsStatement-us.vue?vue&type=script&lang=js"
export * from "./IndicatorsStatement-us.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports